import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { FavCaseSheetApi } from '../api/favcasesheet.api';
import { switchMap, map } from 'rxjs/operators';
import { FavCaseSheetData, FavCaseSheet } from '../../../interfaces/masters/favcasesheet' ;
@Injectable()
export class FavCaseSheetService extends FavCaseSheetData {

    constructor(private api: FavCaseSheetApi) {
      super();
    }
  
  
    list(url: string): Observable<FavCaseSheet[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<FavCaseSheet>{
        return this.api.getById(url);
    }
  
    create(url: string, data:FavCaseSheet): Observable<FavCaseSheet[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:FavCaseSheet): Observable<FavCaseSheet> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  